/**
 * Created by Ning Jiang on 12/11/2017.
 */
import {RandomFeatureIndicatorView} from "./RandomFeatureIndicatorView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";

export class RandomFeatureIndicatorController extends ReelStopPresentationController {

    private _featureSymbol:string = "";
    private _featureTriggered:boolean = false;

    private readonly _view:RandomFeatureIndicatorView;

    constructor(index:number) {
        super(index, "RandomFeatureIndicator");

        this._view = new RandomFeatureIndicatorView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED, (event:GameEvent) => this.hideIndicator());
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        this._featureSymbol = data.activeStackedSymbol;
        this._featureTriggered = data.stackedSpinTriggered;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 1 && this._featureTriggered) {
            this.showIndicator();
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    protected resetFeature():void {
        this.hideIndicator();
        this._featureTriggered = false;
    }

    private showIndicator():void {
        this._view.showIndicator(this._featureSymbol);
    }

    private hideIndicator():void {
        this._view.hideIndicator();
    }
}